export default __webpack_public_path__ + "static/media/tlg.f3bfa87b.png";